import Vue from 'vue';
import axios from 'axios';
import router from '../router';
import EventBus from './EventBus';

Vue.use(EventBus);
const vue = new Vue({});

const API_URL = 'https://api-compliance.meta.com.br/api';

// Add base URL to axios api communication
axios.interceptors.request.use(config => {
  config.url = API_URL + config.url;

  config.headers.common['Key'] = '0778d3d1a38d65de6536cd9dd9b1505d';

  if (vue.$localStorage.get('user')) {
    const user = JSON.parse(vue.$localStorage.get('user'));
    config.headers.common['Authorization'] = `Bearer ${user.access_token}`;
  }

  return config;
});

axios.interceptors.response.use(config => {
  if (!config.data.success && config.data.message === 'TOKEN_INVALID') {
    vue.$localStorage.set('user', '');
    return router.push({ name: 'Login' });
  }

  if (!config.data.success && config.data.message === 'TOKEN_EXPIRED') {
    vue.$events.$emit('refresh-token');
  }

  return config;
});

export default (V) => {
  Object.defineProperties(V.prototype, {
    $http: {
      get() {
        return axios;
      },
      post() {
        return axios;
      },
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/AxiosPlugin.js